import { all } from "redux-saga/effects";

import sagaAuth from "store/sagas/auth";
import sagaUsers from "store/sagas/users";
import sagaVouchers from "store/sagas/vouchers";
import sagaBenefits from "store/sagas/benefits";
import sagaBenefitsTypes from "store/sagas/benefitsTypes";
import sagaChannels from "store/sagas/channels";
import sagaCommercialCampaign from "store/sagas/commercialCampaign";
import sagaStores from "store/sagas/stores";
import sagaPayments from "store/sagas/payments";
import sagaProductsTypes from "store/sagas/productsTypes";
import sagaEvents from "store/sagas/events";
import sagaReports from "store/sagas/reports";
import sagaAttendances from "store/sagas/attendances";
import sagaSections from "store/sagas/sections";
import sagaKafka from "store/sagas/kafka";
import sagaGroups from "store/sagas/groups";
import sagaRoles from "store/sagas/roles";
import sagaSettings from "store/sagas/settings";
import sagaCampaigns from "store/sagas/campaigns";
import sagaRegions from "store/sagas/regions";
import sagaPrizes from "store/sagas/prizes";
import sagaMultipliers from "store/sagas/multipliers";
import sagaPoints from "store/sagas/points";
import { Environment } from "common";

const ENABLE_EAD_API = Environment.getEnvBoolean("REACT_APP_ENABLE_EAD_API");

const sagaDocuments = ENABLE_EAD_API
  ? require("store/sagas/documentsEad").default
  : require("store/sagas/documents").default;

const sagaReasons = ENABLE_EAD_API
  ? require("store/sagas/reasonsEad").default
  : require("store/sagas/reasons").default;

export default function* rootSaga() {
  return yield all([
    sagaAuth(),
    sagaUsers(),
    sagaVouchers(),
    sagaBenefits(),
    sagaBenefitsTypes(),
    sagaStores(),
    sagaPayments(),
    sagaChannels(),
    sagaCommercialCampaign(),
    sagaDocuments(),
    sagaProductsTypes(),
    sagaEvents(),
    sagaReports(),
    sagaAttendances(),
    sagaSections(),
    sagaKafka(),
    sagaGroups(),
    sagaReasons(),
    sagaRoles(),
    sagaSettings(),
    sagaCampaigns(),
    sagaRegions(),
    sagaPrizes(),
    sagaMultipliers(),
    sagaPoints(),
  ]);
}
